(function($) {
  	var getHash = function () {
    	return window.location.hash;
    };
    var updateHash = function (hash) {
        window.location.hash = '#' + hash;
        $('#' + hash).attr('tabindex', -1).focus();
    };
  	if ($(".template-collection")) {
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!apollo.isFilterAjaxClick) {
                apollo.filterParams();
                var newUrl = apollo.filterCreateUrl();
                apollo.filterGetContent(newUrl);
              	apollo.reloadFilter();
            }
            apollo.isFilterAjaxClick = false;
        });
    }
  	$(function(){
      	$('body').on('touchstart.dropdown', '.dropdown-menu', function (e) { 
        	e.stopPropagation(); 
      	});
      	$(document.body).on('click', '[data-toggle="dropdown"]' ,function(){
        	if(!$(this).parent().hasClass('open') && this.href && this.href != '#'){
          		window.location.href = this.href;
        	}
      	});
    })
	$(document).ready(function() {
        apollo.init();
    });
  	var apollo = {
      	isFilterAjaxClick: false,
      	init: function() {
        	this.loginForms();
          	this.initFilter();
        },
      	loginForms: function() {
            function showRecoverPasswordForm() {
                $('#RecoverPasswordForm').show();
                $('#CustomerLoginForm').hide();
            }
            function hideRecoverPasswordForm() {
                $('#RecoverPasswordForm').hide();
                $('#CustomerLoginForm').show();
            }
            $('#RecoverPassword').on('click', function(evt) {
                evt.preventDefault();
                showRecoverPasswordForm();
            });
            $('#HideRecoverPasswordLink').on('click', function(evt) {
                evt.preventDefault();
                hideRecoverPasswordForm();
            });
            if (getHash() == '#recover') {
                showRecoverPasswordForm();
            }
        },
      	resetPasswordSuccess: function() {
            $('#ResetSuccess').show();
        },
      	showLoading: function() {
            $('#loading').show();
        },
        hideLoading: function() {
            $('#loading').hide();
        },
      	initFilter: function() {
            apollo.filterParams();
            apollo.filterSortby();
            apollo.filterMapSidebar();
			
        },
      	filterParams: function() {
            Shopify.queryParams = {};
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
      	filterSortby: function() {
            if (Shopify.queryParams.sort_by) {
                var sortby = Shopify.queryParams.sort_by;
                $("#SortBy").val(sortby);
            }
        },
      	filterCreateUrl: function(baseLink) {
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }
            return location.pathname + "?" + newQuery;
        },
      	filterMapData: function(data) {
          	//Data Product
        	$('#product_list').html($(".product_list", data.responseText).html());
          	//Data Pagging
          	$('#pagination').remove();
          	$('.content_sortPagiBar').html($(".content_sortPagiBar", data.responseText).html());
          	//Data Filter Tags
          	$('#catalog_block').html($("#catalog_block", data.responseText).html());
          	
          	var viewCurrent = $(".change-view.change-view--active").data('view');
          	$('#product_list').removeClass('list').removeClass('grid').addClass(viewCurrent);
        },
      	filterAjaxClick: function(baseLink) {
          	delete Shopify.queryParams.page;
            var newurl = apollo.filterCreateUrl(baseLink);
          	console.log('Link: ' + newurl);
          	apollo.isFilterAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            apollo.filterGetContent(newurl);
        },
      	filterGetContent: function(newurl) {
            $.ajax({
                type: 'GET',
                url: newurl,
                data: {},
                beforeSend:function(){
                  	apollo.showLoading();
                },
                complete: function(data) {
                    apollo.filterMapData(data);
                  	apollo.hideLoading();
                  	apollo.filterMapPaging();
                  	apollo.sidebarMapTagEvents();
                },
                error: function(xhr, text) {
                    apollo.hideLoading();
                    $('#errorJs .modal-content').text($.parseJSON(xhr.responseText).description);
                    $('#errorJs').modal('show');
                }
            });
        },
      	sidebarMapTagEvents: function(){
          	$('.advanced-filter a').click(function(event) {
              	event.preventDefault();
                var currentTags = [];
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }
                if (!window.multiple_filter_sidebar_enable && !$(this).parent().hasClass("active-filter")) {
                  	console.log('No multichoise');
                  	var otherTag = $(this).parents('.catalog_filter_ul').find("li.active-filter");
                    if (otherTag.length > 0) {
                        var tagName = otherTag.data("handle");
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    }
                }

                var dataHandle = $(this).parent().data("handle");
                if (dataHandle) {
                    var tagPos = currentTags.indexOf(dataHandle);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    } else {
                        currentTags.push(dataHandle);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                apollo.filterAjaxClick();
            });
        },
      	sidebarMapTypeEvents: function(){
        	
        },
      	sidebarMapVendorEvents: function(){
        	
        },
  		filterMapView: function() {
            $(".change-view").click(function(event) {
              	event.preventDefault();
                if (!$(this).hasClass("change-view--active")) {
                    if ($(this).data('view') == 'list' ) {
                        Shopify.queryParams.view = "list";
                    } else {
                        Shopify.queryParams.view = "grid";
                    }
                  	$(".change-view").removeClass('change-view--active');
					$(this).addClass('change-view--active');
                    apollo.filterAjaxClick();
                }
            });
        },
      	filterMapSorting: function() {
            $("#SortBy").change(function(event){
                Shopify.queryParams.sort_by = $(this).val();
              	apollo.filterAjaxClick();
            });
        },
      	filterMapPaging: function() {
            $('#pagination .pagination a').click(function(event){
              	event.preventDefault();
                var linkPage = $(this).attr("href").match(/page=\d+/g);
              	if (linkPage) {
                	Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = apollo.filterCreateUrl();
                      	apollo.isFilterAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                      	console.log('Link: ' + newurl);
                        apollo.filterGetContent(newurl);
                        $('body,html').animate({
                            scrollTop: 500
                        }, 600);
                    }
                }
            });
        },
      	filterMapSidebar: function() {
        	apollo.sidebarMapTagEvents();
      		apollo.sidebarMapTypeEvents();
      		apollo.sidebarMapVendorEvents();
      		apollo.filterMapView();
            apollo.filterMapSorting();
      		apollo.filterMapPaging();
        },
      	reloadFilter: function() {
      		$('.advanced-filter.active-filter').removeClass('active-filter');
          	if (Shopify.queryParams.view) {
                $('.change-view.change-view--active').removeClass('change-view--active');
                var view = Shopify.queryParams.view;
                if (view.indexOf('list') >= 0) {
                  	$('.change-view').data('view', 'list').addClass('change-view--active');
                    
                } else {
                    $('.change-view').data('view', 'grid').addClass('change-view--active');
                }
            }
      	}
    }
    
})(jQuery);